import React from "react";
import { Switch, Route, useLocation } from "react-router-dom";

// ✅ CORRECT relative imports
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import Gallery from "./Gallery";

import Menu from "./Menu";
import MenuDetails from "./Menu/MenuDetails";
import BuildMenu from "./BuildMenu";

import Catering from './Service/Catering';
import Decoration from './Service/Decoration';
import Entertainment from "./Service/Entertainment";
import Photography from "./Service/Photography"; 
import New from "./New";

const RoutesWithKey = () => {
  const location = useLocation();

  return (
    <Switch location={location} key={location.pathname}>
      <Route exact path="/" component={Home} />
      <Route exact path="/about" component={About} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/menu" component={Menu} />
      <Route exact path="/menu/:id" component={MenuDetails} />
      <Route exact path="/build-menu" component={BuildMenu} />
      <Route exact path="/gallery" component={Gallery} />
      <Route exact path="/service/catering" component={Catering} />
      <Route exact path="/service/photography" component={Photography} />
      <Route exact path="/service/decoration" component={Decoration} />
      <Route exact path="/service/entertainment" component={Entertainment} />
      <Route exact path ="/pickyourdishes" component={New} />

      
    </Switch>
  );
};

export default RoutesWithKey;